const server = {
  url: "https://fakestoreapi.com",
};

export default server;
